import { signUpPagePromoBanner } from '@gonfalon/dogfood-flags/dogfood-flags';

export enum SignUpPagePromoBanners {
  none = 'none',
  statsigMigrationOffer = 'statsig-migration-offer',
}

const signUpPagePromoBannerValues = new Set<string>(Object.values(SignUpPagePromoBanners));

export const isKnownSignUpPagePromoBanner = (value: string): value is SignUpPagePromoBanners =>
  signUpPagePromoBannerValues.has(value);

export const getActiveSignUpPagePromoBanner = (): SignUpPagePromoBanners | null => {
  const activeBanner = signUpPagePromoBanner();

  if (!isKnownSignUpPagePromoBanner(activeBanner) || activeBanner === SignUpPagePromoBanners.none) {
    return null;
  }

  return activeBanner;
};
